import { api } from './index';

export const instrumentsApi = api.injectEndpoints({
  endpoints: (build) => ({
    searchInstruments: build.query({
      query: (search) => `/instruments?${new URLSearchParams(search).toString()}`,
      providesTags: (res, err, arg) => {
        return [{ type: 'Instruments', id: 'LIST' }]
      },
    }),
    getInstrument: build.query({
      query: ({ instrumentKey, lang }) => `/instruments/${instrumentKey}?lang=${lang}`,
      providesTags: (res, err, arg) => {
        return [{ type: 'Instruments', id: arg.instrumentKey }]
      },
    }),
    getInstrumentDraft: build.query({
      query: ({ instrumentId, lang }) => `/instruments/${instrumentId}/draft?lang=${lang}`,
      providesTags: (res, err, arg) => {
        return [{ type: 'InstrumentDrafts', id: arg.instrumentId }]
      },
    }),
    searchInstrumentNew: build.query({
      query: () => `/instruments/new`,
      providesTags: ['InstrumentNew'],
    }),
    searchInstrumentDrafts: build.query({
      query: ({ lang }) => `/draft-instruments?lang=${lang}`,
      providesTags: [{ type: 'InstrumentDrafts', id: 'LIST' }],
    }),
    getInstrumentKeys: build.query({
      query: ({ lang }) => `/instruments/keys?lang=${lang}`,
      providesTags: ['InstrumentsKeys'],
    }),
    saveInstrumentDraft: build.mutation({
      query({ body, id }) {
        return {
          url: `/instruments/${id}`,
          method: 'PUT',
          body: body
        }
      },
      invalidatesTags: (result, error, arg, meta) => {
        if (error) return [];
        return [
          { type: 'InstrumentDrafts', id: 'LIST' },
          { type: 'InstrumentDrafts', id: arg.id },
        ];
      },
    }),
    revertToPublished: build.query({
      query: ({ id }) => `/instruments-revert-to-published?ids=${id}`,
      invalidatesTags: (result, error, arg, meta) => {
        if (error) return [];
        return [
          { type: 'InstrumentDrafts', id: 'LIST' },
          { type: 'InstrumentDrafts', id: arg.id },
          { type: 'Instruments', id: 'LIST' },
          { type: 'Instruments', id: arg.id },
        ];
      },
    }),
    publish: build.query({
      query: ({ id }) => `/publish-instruments?ids=${id}`,
      invalidatesTags: (result, error, arg, meta) => {
        if (error) return [];
        return [
          { type: 'InstrumentDrafts', id: 'LIST' },
          { type: 'InstrumentDrafts', id: arg.id },
          { type: 'Instruments', id: 'LIST' },
          { type: 'Instruments', id: arg.id },
        ];
      },
      transformResponse: (response, meta, arg) => {
        return response;
      }
    }),
    unpublish: build.query({
      query: ({ id }) => `/unpublish-instruments?ids=${id}`,
      invalidatesTags: (result, error, arg, meta) => {
        if (error) return [];
        return [
          { type: 'InstrumentDrafts', id: 'LIST' },
          { type: 'InstrumentDrafts', id: arg.id },
          { type: 'Instruments', id: 'LIST' },
          { type: 'Instruments', id: arg.id },
        ];
      },
    }),
    deleteDraft: build.query({
      query: ({ id }) => ({
        url: `/instruments/${id}`,
        method: 'DELETE'
      }),
      invalidatesTags: (result, error, arg, meta) => {
        if (error) return [];
        return [
          { type: 'InstrumentDrafts', id: 'LIST' },
          { type: 'InstrumentDrafts', id: arg.id },
        ];
      },
    }),
  }),
});

export const {
  useSearchInstrumentsQuery,
  useLazySearchInstrumentsQuery,
  useGetInstrumentQuery,
  useGetInstrumentDraftQuery,
  useGetInstrumentKeysQuery,
  useSearchInstrumentDraftsQuery,
  useLazySearchInstrumentDraftsQuery,
  useSearchInstrumentNewQuery,
  useLazyRevertToPublishedQuery,
  useLazyPublishQuery,
  useLazyUnpublishQuery,
  useLazyDeleteDraftQuery,

  useSaveInstrumentDraftMutation,
} = instrumentsApi;
